import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { AlertType, Cheque, RetAPI, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { createTheme, ThemeProvider } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import moment from 'moment'
import { Funcoes } from '../../Utils/Funcoes'
import { useNavigate } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'
import { RiEdit2Fill } from 'react-icons/ri'
import { FaTrashAlt } from 'react-icons/fa'
import { ControleChequesService } from '../../Pages/ControleCheques/ControleChequesService'

type Props = {
    cheque: Cheque[],
    handleUpdateChequeList: () => void,
    handleSelectItemClick: (id: number, selected: boolean) => void,
    handleColumnClick: (e: React.ChangeEvent<HTMLInputElement>) => void,
    tipo: TipoStatus,
    selectedAll: boolean,
}

type TipoMap = {
    [key: string]: string
}

type VisibilityState = Record<string, boolean>

export type TipoStatus = | "A" | "B"

interface RowData {
    id: number,
    data_lancamento: string,
    id_banco: number,
    agencia: number,
    agencia_digito: string,
    conta: number,
    conta_digito: string,
    numero: string,
    valor: number,
    id_cliente?: number,
    nome_terceiro?: string,
    data_baixa?: string,
    id_user_baixa?: number,
    status: string,
    dt_representado?: string,
    tipo_cheque: string,
    dt_bom_para?: string,
    destino_cheque?: string,
    observacao?: string,
    id_user_insert?: number,
    dt_cadastro?: string,
    id_user_last_update?: number,
    dt_last_update?: string,
    dt_devolvido?: string,
    nome_cliente: string,
    nome_banco: string,
    selected: boolean,
}

export const GridCheques = React.memo(({ cheque, handleUpdateChequeList, handleSelectItemClick, handleColumnClick, tipo, selectedAll }: Props) => {

    /*
    const xJson = localStorage.getItem("@commerce/column_grid_cheque")

    let json: any = {
        acao: true, 
        data_lancamento: true, 
        nome_cliente: true, 
        nome_banco: true, 
        numero: true,
        valor: true, 
        status: true, 
        tipo_cheque: true, 
    }

    if (xJson) {
        json = JSON.parse(localStorage.getItem("@commerce/column_grid_cheque") || '')
    }
    */

    /*
        useEffect(() => {
    
            if (xJson) {
                if (json) {
                    const newColumnVisibility: VisibilityState = { ...columnVisibility }
                    newColumnVisibility.acao = json.acao
                    newColumnVisibility.data_lancamento = json.data_lancamento
                    newColumnVisibility.nome_cliente = json.nome_cliente
                    newColumnVisibility.nome_banco = json.nome_banco
                    newColumnVisibility.numero = json.numero
                    newColumnVisibility.valor = json.valor
                    newColumnVisibility.status = json.status
                    newColumnVisibility.tipo_cheque = json.tipo_cheque
    
                }
            }
    
        }, [])
        */

    /*
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10, // personaliza o tamanho padrão da página  
    })
    */

    const defaultJson = useMemo(() => {
        return (

            localStorage.getItem("@commerce/column_grid_cheque")
                ? JSON.parse(localStorage.getItem("@commerce/column_grid_cheque") || '')
                : {
                    acao: true,
                    data_lancamento: true,
                    nome_cliente: true,
                    nome_banco: true,
                    numero: true,
                    valor: true,
                    conta: true,
                    agencia: true,
                    status: true,
                    tipo_cheque: true,
                    select: true,
                }
        )
    }, [])

    const [idExcluir, setIdExcluir] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [state, setState] = useState(false)
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(defaultJson)

    let user = useSelector(state => selectUser(state))

    const [cheques, setCheques] = useState<Cheque[]>([])
    const [nomeCheques, setNomeCheques] = useState("")

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EFFECT -------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        setCheques([])
        const timer = setTimeout(() => {
            const newColumnVisibility = { ...columnVisibility }
            newColumnVisibility.select = tipo === "A"
            setColumnVisibility(newColumnVisibility)
            clearTimeout(timer)
        }, 150)

    }, [tipo])

    useEffect(() => {
        setCheques(cheque)
    }, [cheque])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_cheque", JSON.stringify(columnVisibility))
    }, [columnVisibility])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EXCLUIR e FOCUS ----------------------------------------------------
    //--------------------------------------------------------------------------------------------------------------------------------- 
    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setFeedBackVisible(false)
        setIsLoading(true)

        try {

            const retApi: RetAPI = await ControleChequesService.Delete(idExcluir, motivo, senha)

            if (!retApi.error) {
                setFeedBackVisible(true)
                setAlertType("SUCCESS")
                setMessageFeedBack(`Cheque excluído com sucesso`)

                handleUpdateChequeList()

                //setCheques(await ControleChequesService.Filter('', '', ''))
                //setModalShow(false)

            } else {
                setFeedBackVisible(true)
                setAlertType("DANGER")
                setMessageFeedBack(retApi.msg || ``)
                setIsLoading(false)
            }

        } catch (error) {

            setIsLoading(false)
            setFeedBackVisible(true)
            setAlertType("DANGER")
            setMessageFeedBack(`Não foi possível excluir o cheque. Por favor, tente novamente`)
        }

    }, [idExcluir])

    const fecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)

        if (alertType == 'SUCCESS') {
            setModalShow(false)
            setNomeCheques("")
        }

    }, [alertType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        setModalShow(false)
        setNomeCheques("")
    }, [])

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- NAVEGAÇÃO ----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaChequeEdit = (id: number) => {
        navigate(`/c_cheque/edit/${id}`)
    }

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TEMAS --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const theme = createTheme({
        palette: {
            mode: user.modeDark,
            background: {
                default: user.modeDark === 'light' ? '#fff' /* modo escuro */ : '#475569', /* modo escuro */
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- COLUNAS ------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const tipoChequeMap: TipoMap = {
        'P': 'Própio',
        'T': 'Terceiro',
    }

    function mapTipoCheque(tipoCheque: string) {
        return (
            <>
                {tipoChequeMap[tipoCheque] || <div className={`text-red-400`}>N/D</div>}
            </>
        )
    }

    const tipoStatusMap: TipoMap = {
        'N': 'Normal',
        'D': 'Devolvido',
        'R': 'Representado',
    }

    function mapTipoStatus(tipoStatus: string) {
        return (
            <>
                {tipoStatusMap[tipoStatus] || <div className={`text-red-400`}>N/D</div>}
            </>
        )
    }

    const handleCheckBoxClick = (id: number, selected: boolean) => {

        setState(!state)
        handleSelectItemClick(id, selected)

    }

    let colunasArray: MRT_ColumnDef<Cheque>[] = []

    const columns = useMemo<MRT_ColumnDef<Cheque>[]>(() => [

        {
            accessorKey: 'select',
            Header: (props) => {
                return <input type='checkbox' className={`accent-blue-500 h-5 w-5 outline-none cursor-pointer`} onChange={handleColumnClick} checked={selectedAll} />
            },
            header: '',
            size: 120,
            visibleInShowHideMenu: false,
            muiTableBodyCellProps: { align: 'center' },
            muiTableHeadCellProps: { align: 'center' },
            Cell: ((cell: any) => {

                const rowData = cell.row.original as RowData

                return (
                    <div className={`w-full h-[30px]`}>

                        <input
                            id={'checkbox-' + rowData.id}
                            aria-label={rowData.id.toString()}
                            type='checkbox'
                            onChange={() => handleCheckBoxClick(rowData.id, rowData.selected)}
                            className={`accent-blue-500 h-5 w-5 outline-none cursor-pointer`}
                            checked={!!rowData.selected} />

                        <Tooltip
                            style={{ backgroundColor: 'rgb(30, 41, 59)' }}
                            id={'tooltip-checkbox-' + rowData.id}
                            anchorSelect={'#checkbox-' + rowData.id}
                            positionStrategy='fixed' >
                            <span>
                                Selecione para <br />
                                dar baixa
                            </span>
                        </Tooltip>
                    </div>

                )
            }
            )
        },

        {
            accessorKey: 'acao', header: 'Ações', size: 100, visibleInShowHideMenu: true, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },
            Cell: ((cell: any) => {

                const rowData = cell.row.original as RowData

                const navegar = () => {
                    navegarTelaChequeEdit(rowData.id)
                }

                const handleExcluirClick = () => {

                    const timerExcluir = setTimeout(() => {
                        setIdExcluir(rowData.id)
                        setNomeCheques(rowData.numero.toString())
                        setModalShow(true)

                        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement

                        if (divPerfil) {
                            divPerfil.classList.add('hidden')
                        }

                        let menuFiltro = document.getElementById("divMenuFiltroCheque") as HTMLDivElement
                        let menuInputs = document.getElementById("divInputsCheque") as HTMLDivElement
                        let bodySearchBanco = document.getElementById("bodySearchBox-banco") as HTMLDivElement
                        let bodySearchCliente = document.getElementById("bodySearchBox-cliente") as HTMLDivElement

                        if (menuFiltro) {

                            bodySearchBanco.classList.remove("visible")
                            bodySearchCliente.classList.remove("visible")

                            menuInputs.classList.add("invisible")

                            const timer = setTimeout(() => {
                                menuFiltro.classList.remove("max-h-[1000px]")
                                menuFiltro.classList.add("max-h-[0px]")
                                clearTimeout(timer)
                            }, 100)
                        }

                        clearTimeout(timerExcluir)
                    }, 0)
                }

                return (
                    <div className={`flex items-center w-full h-[30px]`}>

                        <button
                            onClick={navegar} data-tooltip-id={'tooltip-editar-' + rowData.id} id={'link-' + rowData.id}
                            className={`flex items-center justify-center 
                                      text-white transition-all duration-300 
                                      hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                      bg-sky-500`} >
                            <RiEdit2Fill size="20px" />

                            <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-' + rowData.id} anchorSelect={'#link-' + rowData.id} positionStrategy="fixed" place='top'>
                                <span>Editar</span>
                            </Tooltip>

                        </button>

                        <button
                            onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-' + rowData.id} id={'btn-excluir-' + rowData.id}
                            className={`flex items-center justify-center 
                                      text-white transition-all duration-300 
                                      hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                      bg-red-500 ml-2`}>
                            <FaTrashAlt size="18px" />

                            <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-' + rowData.id} anchorSelect={'#btn-excluir-' + rowData.id} positionStrategy="fixed" place='top-end'>
                                <span>Excluir</span>
                            </Tooltip>

                        </button>

                    </div>

                )
            })
        },

        {
            accessorKey: 'nome_cliente', visibleInShowHideMenu: true, header: 'Nome Cliente', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.nome_cliente ? rowData.nome_cliente : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'nome_banco', visibleInShowHideMenu: true, header: 'Nome do Banco', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.nome_banco ? rowData.nome_banco : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'numero', visibleInShowHideMenu: true, header: 'Número', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.numero ? rowData.numero : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'valor', visibleInShowHideMenu: true, header: 'Valor (R$)', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.valor ? Funcoes.numberFormat(rowData.valor, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'conta', visibleInShowHideMenu: true, header: 'Conta', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.conta ? rowData.conta : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'agencia', visibleInShowHideMenu: true, header: 'Agência', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.agencia ? rowData.agencia : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'status', visibleInShowHideMenu: true, header: 'Status', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData
                const tipoStatusCheque: string = rowData.status

                return mapTipoStatus(tipoStatusCheque)
            }
        },

        {
            accessorKey: 'tipo_cheque', visibleInShowHideMenu: true, header: 'Tipo de Cheque', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData
                const tipoDoCheque: string = rowData.tipo_cheque

                return mapTipoCheque(tipoDoCheque)
            }
        },

        {
            accessorKey: 'data_lancamento', visibleInShowHideMenu: true, header: 'Data de Lançamento', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.data_lancamento ? moment(rowData.data_lancamento).format('DD/MM/YYYY') : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'dt_bom_para', visibleInShowHideMenu: true, header: 'Data de Vencimento', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.dt_bom_para ? moment(rowData.dt_bom_para).format('DD/MM/YYYY') : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

    ], [cheque]
    )

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TABLE --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const table = useMaterialReactTable({
        paginationDisplayMode: 'pages',
        columns: columns,
        data: cheques,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,
        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        localization: MRT_Localization_PT_BR,
        enableEditing: false,
        enableTopToolbar: false,
        enableColumnActions: false,
        enableColumnFilters: false,
        enableHiding: false,
        enableFilters: false,
        enableMultiSort: false,
        enableSorting: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (
        <>

            <ThemeProvider theme={theme}>
                <MaterialReactTable table={table} />
            </ThemeProvider>

            <ModalExcluirDados
                show={modalShow}
                isLoading={isLoading}
                message={`Deseja excluir o cheque - ${nomeCheques || ''}?`}
                alertType={alertType}
                feedBackVisible={feedBackVisible}
                messageFeedBack={messageFeedBack}
                closeModalEvent={fecharModalExcluirDados}
                excluirEvent={handleExcluir}
                fecharModalEvent={buttonFecharModalExcluirDados}
            />

        </>
    )

})